import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const appointmentImporterSelectors = importerSelectors(
  'appointment.importer',
)

export default appointmentImporterSelectors
